import React, { memo, useCallback } from 'react';

import { ReasonEditor } from '@lender/ckeditor-custom-build';
import { Typography } from '@mui/material';
import HelperText from '@sharedCR/coreDesignSystem/form/HelperText';
import RequiredIcon from '@sharedCR/coreDesignSystem/form/RequiredIcon';
import FormEditor from 'app/shared/components/forms/FormEditor';
import PropTypes from 'prop-types';

import { getMinHeight } from './FormGeneratorRichTextEditor.utils';

const FormGeneratorRichTextEditor = ({
  isHidden = false,
  label,
  required = false,
  error = false,
  helperText = '',
  name,
  'data-field-id': dataFieldId = null,
  ...props
}) => {
  const onChange = useCallback(
    value => props.onChange({ target: { ...props, label, required, name, value } }),
    [props, label, required, name],
  );

  if (isHidden) {
    return null;
  }

  return (
    <div
      className="form-generator__titled-input__container flex flex-col w-full"
      data-field-id={dataFieldId}
    >
      <Typography className="form-generator__titled-input__title" variant="regular14">
        {label}
        {required && <RequiredIcon />}
      </Typography>

      <FormEditor
        {...props}
        ariaLabel={label || name}
        className="mt-8 mb-4"
        editorType={ReasonEditor}
        error={error}
        isEditorHeaderAllowed={false}
        minHeight={getMinHeight(props.rows)}
        onChange={onChange}
      />

      {helperText && <HelperText error={error}>{helperText}</HelperText>}
    </div>
  );
};

FormGeneratorRichTextEditor.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  'data-field-id': PropTypes.string,
  rows: PropTypes.number,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  isHidden: PropTypes.bool,
  required: PropTypes.bool,
};

export default memo(FormGeneratorRichTextEditor);
